export default "__VITE_ASSET__DJBF39wq__"